// @flow
import PillBadge from './PillBadge';
export default PillBadge;
